import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { CleanUpStatusDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-cleanupstatus-container',
  templateUrl: './cleanupstatus-container.component.html',
  styleUrls: ['./cleanupstatus-container.component.scss']
})
export class CleanUpStatusContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  cleanupstatuss$: Observable<CleanUpStatusDto[]>;
  loading: boolean;
  isLoadingCleanUpStatus$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
  ) {}

  ngOnInit() {
    this.isLoadingCleanUpStatus$ = this.gatwayFacade.isLoadingGateway("CleanUpStatus");
    this.cleanupstatuss$ = this.gatwayFacade.loadGateway("CleanUpStatus");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteCleanUpStatus(deletedValue: any) {
    this.gatwayFacade.remove("CleanUpStatus", deletedValue);
  }


// this method control both the create and update

  onSubmitCleanUpStatus(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.CleanUpStatuss;

// declare two empty arrays to hold update and create data
  const allUpdates = [] ;
  const addAllCleanUpStatus = [];


// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllCleanUpStatus.push(pullData[i]);
    }
  }

// check if the addAllCleanUpStatus array is not empty, then dispatch the data to the store
   if(addAllCleanUpStatus.length > 0) {
    this.gatwayFacade.add('CleanUpStatus', addAllCleanUpStatus);
   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('CleanUpStatus', allUpdates, ['id']);
  }

   }


}
